package com.zaurh.mapquiz.data.response

import com.zaurh.mapquizwebsite.domain.model.UserDataDO
import com.zaurh.mapquizwebsite.utils.EMPTY
import kotlinx.serialization.Serializable

@Serializable
data class SignInDO(
    val token: String = EMPTY,
    val userData: UserDataDO = UserDataDO()
)
